import * as D from "@radix-ui/react-dialog"
import { tv } from "@utils/tw"
import { ReactElement, Suspense, useState } from "react"
import { YouTubeVideo } from "./YouTubeVideo"
import { Button } from "@components/ui/Button"
import { trackEvent } from "@features/tracking/tracking"
import { trackFilmInterest } from "@features/tracking/film-history"

type Props = {
  /** The YouTube ID or YouTube URL of a video to play */
  videoId: string
  filmUri?: string
  /** The trigger */
  children: ReactElement
}

export function PlayTrailerButton(props: Props) {
  const styles = trailerStyles()
  const [open, setOpen] = useState(false)

  return (
    <D.Root open={open} onOpenChange={setOpen}>
      {props.children && (
        <D.Trigger
          asChild
          onClick={(e) => {
            trackEvent("Play Trailer", {}, e.currentTarget)
            trackFilmInterest(props.filmUri || "", "trailer")
          }}
        >
          {props.children}
        </D.Trigger>
      )}
      <D.Portal>
        <D.Overlay className={styles.overlay()} />
        <Suspense fallback={null}>
          <D.Content
            className={styles.content()}
            // onEscapeKeyDown={(e) => {
            //   requestCancel(e)
            // }}
            onClick={(e) => {
              setOpen(false)
            }}
          >
            <YouTubeVideo
              videoId={props.videoId}
              autoplay
              playsInline={false}
              className="w-full max-h-full rounded-md overflow-hidden"
            />
          </D.Content>
        </Suspense>
      </D.Portal>
    </D.Root>
  )
}

const trailerStyles = tv({
  slots: {
    overlay: "radix-backdrop",
    content: [
      "radix-modal-animation @container-normal",
      "fixed z-50 left-0 top-0 w-full h-full flex justify-center items-center p-4 md:p-9",
      "rounded-md shadow-md focus:outline-none overflow-hidden",
    ],
    title: "type-title-panel",
    description: "mb-5 mt-[15px] type-body",
    buttons: "flex justify-end gap-[25px]",
  },
})
